<template>
  <div>
    <label class="label-form-css" for="login_donor_portal_password">{{ label }}</label>
    <div class="row" style="align-items: center;margin: 0">
      <input
          :type="type"
          class="form-control input-form-css col"
          :class = "{'errorInput':outsideErrorAction}"
          id="login_donor_portal_password"
          name="scp_password"
          aria-describedby="helpPassword"
          @focus="$emit('focus_'  + name, false)"
          v-model.trim="password"
      >
      <font-awesome-icon
          class="awesome-icon"
          :icon="['fas', 'eye']"
          @click="type = type === 'password' ? 'text' : 'password'"
          style="padding: 0 0 0 5px; margin-left: 5px; cursor: pointer; font-size: 18px;"
      />
    </div>

    <small
        id="helpPassword"
        class="form-text text-muted"
        :style=" passwordMessage === errorMessage?'color: red!important;':''"
    >
      {{ passwordMessage }}
    </small>
  </div>
</template>

<script>
export default {
  name: "passwordInput",
  props: [ 'errorMessage', 'message', 'label', 'name', 'outsideErrorAction' ],
  data() {
    return {
      type: 'password',
      password: '',
      passwordMessage: '',
      nameField: '',
    }
  },
  watch: {
    password: function (val) {
      if (/\s/.test(val)) {
        this.passwordMessage = this.errorMessage
      } else {
        this.passwordMessage = this.message
      }
      this.$emit('change_'  + this.name, val.trim())
    }
  },
  created() {
    this.nameField = this.name
    this.passwordMessage = this.message
  },
}
</script>

<style scoped>
.awesome-icon {
  padding: 0 0 0 5px;
  margin-left: 5px;
  cursor: pointer;
  font-size: 18px;
}
svg path{
  stroke: var(--ButtonColor);
  fill: var(--ButtonColor);
}
.errorInput{
  border-color: red;
}
</style>
